<template>
  <div>
    <div>
      <w-button data-test="removeStickerButton" @click="removeStickerLayout"
                :icon="iconStickerRemoved" :size="size"
                :color="color"
      />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import {FilterVideoType} from '@/enum/FilterVideoEnum';
import {SourceVideoType} from '@/enum/SourceVideoEnum';
import store from '@/store';
import {StickerPosition} from '@/enum/StickerPositionEnum';
import {
  RECORD_STICKER_FILTER,
  RECORD_STICKER_FULLSCREEN,
  RECORD_STICKER_MUTE,
  RECORD_STICKER_POSITION,
  RECORD_STICKER_VIDEO_MUTE,
} from '@/store/recordingState/recordStateAction';
import VideoSource from '@/components/recorder/videoLayout/source/VideoSource.vue';
import WButton from '@/components/wrapper/w-button.vue';
import {ActionEvent} from '@/enum/TrackerEnum';
import {toggleStickerVisibility} from '@/utils/stickerControlUtil';


@Component({
  components: {WButton, VideoSource},
  computed: {},
})
export default class StickerRemoveStickerButton extends Vue {
  @Prop({default: 'text'})
  private color!: string;

  @Prop({default: 'small'})
  private size!: string;


  get isVideoMute(): boolean {
    return store.getters.isStickerVideoMute;
  }

  get isStickerRemoved(): boolean {
    return this.stickerPosition === StickerPosition.NONE;
  }

  get iconStickerRemoved(): string {
    if (this.isStickerRemoved) {
      return 'account-off-outline';
    } else {
      return 'account-outline';
    }
  }

  get stickerPosition(): StickerPosition {
    return store.getters.getStickerPosition;
  }

  public removeStickerLayout() {
    toggleStickerVisibility();
  }

}
</script>
<style lang="scss" scoped>
@import '@/scss/shadows.scss';


</style>
